import { Asserts, boolean, object, ref, string } from 'yup';

import { validationLang } from './common';
import { email, password } from './commonValidation';

export const signInSchema = object({
  email,
  password,
  rememberMe: boolean().required(),
});

export type SignInSchemaDataType = Asserts<typeof signInSchema>;

export const forgotPasswordSchema = object({
  email,
});

export type ForgotPasswordSchemaDataType = Asserts<
  typeof forgotPasswordSchema
>;

export const setNewPasswordSchema = object({
  password,
  passwordAgain: string()
    .oneOf([ref('password')], validationLang.passwordShouldMatch)
    .required(),
});

export type SetNewPasswordSchemaDataType = Asserts<
  typeof setNewPasswordSchema
>;

export const updatePasswordSchema = object({
  oldPassword: password,
  password,
  passwordAgain: string()
    .oneOf([ref('password')], validationLang.passwordShouldMatch)
    .required(),
});

export type UpdatePasswordSchemaDataType = Asserts<
  typeof updatePasswordSchema
>;

export const signUpSchema = object({
  email,
  emailAgain: string()
    .oneOf([ref('email')], validationLang.emailShouldMatch)
    .required(),
  password,
  // passwordAgain: string()
  //   .oneOf([ref('password')], validationLang.passwordShouldMatch)
  //   .required(),
  firstName: string().trim().min(2).max(64).required(),
  lastName: string().trim().min(2).max(64).required(),
  country: string().required(),
  agreement: boolean().required().oneOf([true]),
});

export type SignUpSchemaDataType = Asserts<typeof signUpSchema>;

export const addPaymentMethodSchema = object({
  firstName: string().trim().min(2).max(64).required(),
  lastName: string().trim().min(2).max(64).required(),
  expDate: string().creditCardExpirationDate().required(),
  cvc: string().creditCardCvc().required(),
  number: string().creditCardNumber().required(),
});

export type AddPaymentMethodDataType = Asserts<
  typeof addPaymentMethodSchema
>;
